import React from 'react';

export const HubFormBMarker: React.FC = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#FF0000" />
      <path
        d="M7.29119 14V6.176H9.96719C10.5112 6.176 10.9992 6.236 11.4312 6.356C11.8632 6.468 12.2072 6.664 12.4632 6.944C12.7192 7.224 12.8472 7.616 12.8472 8.12C12.8472 8.464 12.7552 8.804 12.5712 9.14C12.3952 9.468 12.1472 9.692 11.8272 9.812V9.86C12.2272 9.964 12.5592 10.168 12.8232 10.472C13.0952 10.768 13.2312 11.176 13.2312 11.696C13.2312 12.232 13.0952 12.668 12.8232 13.004C12.5512 13.34 12.1872 13.592 11.7312 13.76C11.2752 13.92 10.7632 14 10.1952 14H7.29119ZM9.05519 9.308H9.88319C10.3152 9.308 10.6272 9.224 10.8192 9.056C11.0192 8.888 11.1192 8.664 11.1192 8.384C11.1192 8.08 11.0192 7.864 10.8192 7.736C10.6192 7.608 10.3112 7.544 9.89519 7.544H9.05519V9.308ZM9.05519 12.632H10.0512C11.0192 12.632 11.5032 12.28 11.5032 11.576C11.5032 11.232 11.3832 10.988 11.1432 10.844C10.9032 10.692 10.5392 10.616 10.0512 10.616H9.05519V12.632Z"
        fill="white"
      />
    </svg>
  );
};

export const HubFormAMarker: React.FC = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#FF0000" />
      <path
        d="M9.43379 9.7L9.27379 10.3H10.6638L10.5138 9.7C10.4271 9.37333 10.3371 9.02667 10.2438 8.66C10.1571 8.29333 10.0705 7.94 9.98379 7.6H9.94379C9.86379 7.94667 9.78046 8.30333 9.69379 8.67C9.61379 9.03 9.52712 9.37333 9.43379 9.7ZM7.07379 13L9.11379 6.48H10.8838L12.9238 13H11.3638L10.9638 11.45H8.97379L8.57379 13H7.07379Z"
        fill="white"
      />
    </svg>
  );
};

export const HubFormCMarker: React.FC = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" fill="#FF0000" />
      <path
        d="M10.6958 14.144C10.0398 14.144 9.43581 13.992 8.88381 13.688C8.33181 13.384 7.88781 12.936 7.55181 12.344C7.22381 11.744 7.05981 11.008 7.05981 10.136C7.05981 9.272 7.22781 8.536 7.56381 7.928C7.90781 7.312 8.35981 6.844 8.91981 6.524C9.48781 6.196 10.0998 6.032 10.7558 6.032C11.2598 6.032 11.7118 6.136 12.1118 6.344C12.5118 6.544 12.8438 6.78 13.1078 7.052L12.1718 8.18C11.9718 7.996 11.7598 7.848 11.5358 7.736C11.3198 7.616 11.0718 7.556 10.7918 7.556C10.4398 7.556 10.1158 7.656 9.81981 7.856C9.53181 8.056 9.29981 8.344 9.12381 8.72C8.95581 9.096 8.87181 9.548 8.87181 10.076C8.87181 10.876 9.04381 11.5 9.38781 11.948C9.73181 12.396 10.1918 12.62 10.7678 12.62C11.0878 12.62 11.3718 12.548 11.6198 12.404C11.8758 12.26 12.0998 12.088 12.2918 11.888L13.2278 12.992C12.5718 13.76 11.7278 14.144 10.6958 14.144Z"
        fill="white"
      />
    </svg>
  );
};

export const HubFormBuildingImage: React.FC = () => {
  return (
    <svg
      width="217"
      height="159"
      viewBox="0 0 217 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4467_26219)">
        <path
          d="M12.918 72.0276V158.416H216.604V72.0276L125.064 14.9638V9.41589H104.062V14.9638L12.918 72.0276Z"
          fill="url(#paint0_linear_4467_26219)"
        />
        <path
          d="M12.918 158.416V72.0276L104.062 14.9638V9.41589H125.064V14.9638L216.604 72.0276V158.416"
          stroke="#838383"
          strokeWidth="0.198138"
        />
        <path
          d="M13.3164 72.0276H216.607"
          stroke="black"
          strokeWidth="0.198138"
          strokeDasharray="0.4 0.4"
        />
        <path
          d="M8.91797 65.129L13.245 64.9664L10.9407 61.3004L8.91797 65.129ZM25.8507 54.4856L21.5236 54.6482L23.828 58.3143L25.8507 54.4856ZM11.7754 63.3329L11.9749 63.6504L23.1929 56.5992L22.9933 56.2817L22.7937 55.9642L11.5758 63.0155L11.7754 63.3329Z"
          fill="#FF3939"
        />
        <path
          d="M2.91797 54.4159L7.24504 54.2533L4.94067 50.5872L2.91797 54.4159ZM66.4157 14.503L62.0886 14.6656L64.393 18.3317L66.4157 14.503ZM5.77537 52.6198L5.97493 52.9373L63.7579 16.6166L63.5583 16.2991L63.3587 15.9816L5.5758 52.3023L5.77537 52.6198Z"
          fill="#FF3939"
        />
        <path
          d="M12.918 71.8061L0.41797 50.1555"
          stroke="#FF3939"
          strokeWidth="0.198138"
          strokeDasharray="0.4 0.4"
        />
        <path
          d="M30.418 61.1362L22.918 48.1458"
          stroke="#FF3939"
          strokeWidth="0.198138"
          strokeDasharray="0.4 0.4"
        />
        <path
          d="M76.418 32.1362L63.918 10.4856"
          stroke="#FF3939"
          strokeWidth="0.198138"
          strokeDasharray="0.4 0.4"
        />
        <path
          d="M168.918 71.9856L171.216 68.3155L166.888 68.1605L168.918 71.9856ZM176.918 47.4856L172.842 48.9465L176.145 51.7462L176.918 47.4856ZM169.039 68.6128L169.411 68.6553C169.724 65.9194 170.482 62.4155 171.493 59.0399C172.505 55.6608 173.761 52.4379 175.058 50.2525L174.736 50.0611L174.413 49.8696C173.07 52.1316 171.793 55.4214 170.775 58.8248C169.755 62.2317 168.985 65.78 168.666 68.5702L169.039 68.6128Z"
          fill="#FF3939"
        />
        <g clipPath="url(#clip1_4467_26219)">
          <line
            x1="171.996"
            y1="40.3434"
            x2="174.125"
            y2="36.9568"
            stroke="#424242"
            strokeWidth="0.5"
          />
          <line
            x1="187.05"
            y1="49.8401"
            x2="189.179"
            y2="46.4535"
            stroke="#606060"
            strokeWidth="0.25"
          />
        </g>
        <rect
          x="169.263"
          y="41.8735"
          width="9.5"
          height="20.323"
          rx="1.75"
          transform="rotate(-57.85 169.263 41.8735)"
          stroke="#424242"
          strokeWidth="0.5"
        />
        <rect x="69.918" y="0.485596" width="20" height="20" rx="10" fill="#FF0000" />
        <path
          d="M79.2385 10.5256L79.0465 11.2456H80.7145L80.5345 10.5256C80.4305 10.1336 80.3225 9.7176 80.2105 9.2776C80.1065 8.8376 80.0025 8.4136 79.8985 8.0056H79.8505C79.7545 8.4216 79.6545 8.8496 79.5505 9.2896C79.4545 9.7216 79.3505 10.1336 79.2385 10.5256ZM76.4065 14.4856L78.8545 6.6616H80.9785L83.4265 14.4856H81.5545L81.0745 12.6256H78.6865L78.2065 14.4856H76.4065Z"
          fill="white"
        />
        <rect x="30.918" y="41.4856" width="20" height="20" rx="10" fill="#FF0000" />
        <path
          d="M38.2092 55.4856V47.6616H40.8852C41.4292 47.6616 41.9172 47.7216 42.3492 47.8416C42.7812 47.9536 43.1252 48.1496 43.3812 48.4296C43.6372 48.7096 43.7652 49.1016 43.7652 49.6056C43.7652 49.9496 43.6732 50.2896 43.4892 50.6256C43.3132 50.9536 43.0652 51.1776 42.7452 51.2976V51.3456C43.1452 51.4496 43.4772 51.6536 43.7412 51.9576C44.0132 52.2536 44.1492 52.6616 44.1492 53.1816C44.1492 53.7176 44.0132 54.1536 43.7412 54.4896C43.4692 54.8256 43.1052 55.0776 42.6492 55.2456C42.1932 55.4056 41.6812 55.4856 41.1132 55.4856H38.2092ZM39.9732 50.7936H40.8012C41.2332 50.7936 41.5452 50.7096 41.7372 50.5416C41.9372 50.3736 42.0372 50.1496 42.0372 49.8696C42.0372 49.5656 41.9372 49.3496 41.7372 49.2216C41.5372 49.0936 41.2292 49.0296 40.8132 49.0296H39.9732V50.7936ZM39.9732 54.1176H40.9692C41.9372 54.1176 42.4212 53.7656 42.4212 53.0616C42.4212 52.7176 42.3012 52.4736 42.0612 52.3296C41.8212 52.1776 41.4572 52.1016 40.9692 52.1016H39.9732V54.1176Z"
          fill="white"
        />
        <rect x="147" y="43.7124" width="20" height="20" rx="10" fill="#FF0000" />
        <path
          d="M157.696 57.8564C157.04 57.8564 156.436 57.7044 155.884 57.4004C155.332 57.0964 154.888 56.6484 154.552 56.0564C154.224 55.4564 154.06 54.7204 154.06 53.8484C154.06 52.9844 154.228 52.2484 154.564 51.6404C154.908 51.0244 155.36 50.5564 155.92 50.2364C156.488 49.9084 157.1 49.7444 157.756 49.7444C158.26 49.7444 158.712 49.8484 159.112 50.0564C159.512 50.2564 159.844 50.4924 160.108 50.7644L159.172 51.8924C158.972 51.7084 158.76 51.5604 158.536 51.4484C158.32 51.3284 158.072 51.2684 157.792 51.2684C157.44 51.2684 157.116 51.3684 156.82 51.5684C156.532 51.7684 156.3 52.0564 156.124 52.4324C155.956 52.8084 155.872 53.2604 155.872 53.7884C155.872 54.5884 156.044 55.2124 156.388 55.6604C156.732 56.1084 157.192 56.3324 157.768 56.3324C158.088 56.3324 158.372 56.2604 158.62 56.1164C158.876 55.9724 159.1 55.8004 159.292 55.6004L160.228 56.7044C159.572 57.4724 158.728 57.8564 157.696 57.8564Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4467_26219"
          x1="114.761"
          y1="9.41589"
          x2="114.761"
          y2="158.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A2A1A1" />
          <stop offset="0.975962" stopColor="#D9D9D9" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_4467_26219">
          <rect width="217" height="159" fill="white" />
        </clipPath>
        <clipPath id="clip1_4467_26219">
          <rect
            x="168.918"
            y="41.9521"
            width="10"
            height="20.823"
            rx="2"
            transform="rotate(-57.85 168.918 41.9521)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
